/**
 * @file SendText.jsx
 * @description SendText component for sending text messages to customers.
 * @component SendText
 * @exports SendText - Main component for sending text messages to customers.
 */

import React, { useState } from "react";
import { Modal, Box, Typography, TextField, Button } from "@mui/material";
import { sendText } from "../../../services/customerinfoModule/historyServices";
import { getcustomerprofilebyguid } from "../../../services/customerinfoModule/profileServices";

const SendText = ({ customerguid }) => {
  const [open, setOpen] = useState(false);
  const [sendTextValue, setSendTextValue] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSendText = async () => {
    if (!sendTextValue.trim()) {
      setErrorMsg("Message cannot be empty.");
      return;
    }
    setErrorMsg("");
    setLoading(true);
    try {
      const customer = await getcustomerprofilebyguid({ customerguid });
      if (customer && customer[0].customeruniqueid) {
        const data = {
          to: customer[0].customeruniqueid,
          message: sendTextValue,
          customerguid: customerguid,
          agentguid: localStorage.getItem("userguid"),
        };
        await sendText(data);
      }
      setSendTextValue("");
      setOpen(false);
    } catch (error) {
      setErrorMsg("Failed to send message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // If used in menu, render as a clickable label that opens the modal

  return (
    <>
      <div style={{ cursor: "pointer" }} onClick={() => setOpen(true)}>
        Send Text
      </div>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            width: 400,
            p: 3,
            bgcolor: "background.paper",
            borderRadius: 2,
            mx: "auto",
            mt: 10,
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Typography variant="h6">Send Text</Typography>
          <TextField
            label="Message"
            fullWidth
            value={sendTextValue}
            onChange={(e) => setSendTextValue(e.target.value)}
            error={!!errorMsg}
            helperText={errorMsg}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSendText}
              disabled={loading}
            >
              {loading ? "Sending..." : "Send"}
            </Button>
            <Button variant="outlined" onClick={() => setOpen(false)}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default SendText;
